// =====================================================================
// Assessment Center — Landing page.
// Full-screen role selection. This is the app's root route ("/").
// =====================================================================
import { useNavigate } from "react-router-dom";
import { GraduationCap, Presentation, ArrowRight } from "lucide-react";

const roles = [
  {
    role: "student" as const,
    title: "Student",
    icon: GraduationCap,
    description: "Take exams, view results and track your progress.",
    to: "/login/student",
  },
  {
    role: "instructor" as const,
    title: "Instructor",
    icon: Presentation,
    description: "Create exams, manage question banks, review submissions and publish grades.",
    to: "/login/instructor",
  },
];

export default function LandingPage() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-white px-4 py-12 font-body">
      <div className="mb-10 flex flex-col items-center text-center">
        <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-navy-700 font-display text-2xl font-bold text-white shadow-soft">
          AH
        </div>
        <h1 className="font-display text-3xl font-semibold tracking-tight text-navy-900 sm:text-4xl">
          AviationHub Assessment Center
        </h1>
        <p className="mt-2 max-w-md text-sm text-slate-500 sm:text-base">
          Choose how you'd like to continue.
        </p>
      </div>

      <div className="grid w-full max-w-3xl gap-6 sm:grid-cols-2">
        {roles.map(({ role, title, icon: Icon, description, to }) => (
          <button
            key={role}
            onClick={() => navigate(to)}
            className="group flex flex-col items-start rounded-card border border-border-soft bg-white p-8 text-left shadow-soft transition-all duration-200 hover:-translate-y-1 hover:border-navy-300 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-navy-300"
          >
            <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-navy-50 text-navy-700 transition-colors group-hover:bg-navy-700 group-hover:text-white">
              <Icon size={28} strokeWidth={1.75} />
            </div>
            <h2 className="mt-5 font-display text-xl font-semibold text-navy-900">{title}</h2>
            <p className="mt-2 text-sm leading-relaxed text-slate-500">{description}</p>
            <span className="mt-5 inline-flex items-center gap-1 text-sm font-medium text-navy-700">
              Continue as {title}
              <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
            </span>
          </button>
        ))}
      </div>

      <p className="mt-10 text-xs text-slate-400">Assessment Center · AviationHub</p>
    </div>
  );
}
